






import Vue from "vue";
import Component from "vue-class-component";
import moment from "moment";
import "moment/locale/es-mx";
moment.locale("es-mx");

@Component
export default class ClockComponent extends Vue {
  lastDatetime() {
    this.datetime = moment(Date.now()).format("LL - LTS");
  }

  datetime: string = moment(Date.now()).format("LL - LTS");
  timer: number = 0;

  created() {
    this.timer = setInterval(this.lastDatetime, 1000);
  }
  beforeDestroy() {
    clearInterval(this.timer);
  }
}
